export default "__VITE_ASSET__CkF$s8uK__"